// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"CustomError_errorMessage__s7GoK","errorMessageDefault":"CustomError_errorMessageDefault__Qq20t","link":"CustomError_link__SEDur","or":"CustomError_or___3K0E"};